import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeRoundDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHomeRoundDoor"><Path d="M12 2.8208L3 8.4458V21H9.5V16.5C9.5 15.1193 10.6193 14 12 14C13.3807 14 14.5 15.1193 14.5 16.5V21H21V8.4458L12 2.8208Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeRoundDoor;
